export const DEFAULT_COLOR = "#ce0f0f";

export const STORAGE_ID = "dnd-map-data";

export const pieceSizeInput = document.getElementById("pieceSize");
export const mapZoomInput = document.getElementById("mapZoom");
export const mapSrcLabel = document.getElementById("mapSrcLabel");
export const imgUploadError = document.getElementById("imgUploadError");
export const characterCount = document.getElementById("charCount");
export const mainControlsContent = document.getElementById("mainControls");

export const iconListClasses = [
  "artificer",
  "barbarian",
  "bard",
  "cleric",
  "druid",
  "fighter",
  "monk",
  "paladin",
  "ranger",
  "rogue",
  "sorcerer",
  "warlock",
  "wizard",
];
export const iconListRaces = [
  "aarakocra",
  "aasimar",
  "bugbear",
  "dragonborn",
  "dwarf",
  "elf",
  "firbolg",
  "genasi",
  "gnome",
  "goblin",
  "goliath",
  "halfling",
  "human",
  "kenku",
  "kobold",
  "lizardfolk",
  "orc",
  "tabaxi",
  "tiefling",
  "triton",
  "yuan-ti",
];
export const iconListMonsters = [
  "aberration",
  "beast",
  "celestial",
  "construct",
  "dragon",
  "elemental",
  "fey",
  "fiend",
  "giant",
  "humanoid",
  "monstrosity",
  "ooze",
  "plant",
  "undead",
];
